import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const getAgeGroups = async () => {
  const { data } = await axios(`${API_URL}/age-group`);
  return data;
};
